module.exports = __webpack_public_path__ + "img/bg_right.63c511d7.png";